"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { SlidingNumber } from "../animations/SlidingNumber/SlidingNumber.js";
import { notificationBadgeVariants } from "./NotificationBadge.variants.js";
const DEFAULT_MAX_COUNT = 99;
const DEFAULT_OFFSET_TOP = -10;
const DEFAULT_OFFSET_TOP_XS = -3;
const DEFAULT_OFFSET_HORIZONTAL = -10;
const DEFAULT_OFFSET_HORIZONTAL_XS = -3;
function formatCount(count, maxCount) {
    return count > maxCount ? `${maxCount}+` : String(count);
}
function toCssValue(value) {
    return 'number' == typeof value ? `${value}px` : value ?? '';
}
function computePositionStyle(offsetTop, offsetRight, offsetLeft, isDot) {
    const defaultTop = isDot ? DEFAULT_OFFSET_TOP_XS : DEFAULT_OFFSET_TOP;
    const defaultHorizontal = isDot ? DEFAULT_OFFSET_HORIZONTAL_XS : DEFAULT_OFFSET_HORIZONTAL;
    const style = {
        top: toCssValue(offsetTop ?? defaultTop)
    };
    if (void 0 === offsetLeft) style.right = toCssValue(offsetRight ?? defaultHorizontal);
    else {
        style.left = toCssValue(offsetLeft);
        style.right = 'auto';
    }
    return style;
}
const NotificationBadge_NotificationBadge = /*#__PURE__*/ forwardRef(function({ count, showZero = false, maxCount = DEFAULT_MAX_COUNT, size = 'md', emphasis = 'regular', offsetTop, offsetRight, offsetLeft, animated = false, children, className, ...props }, ref) {
    const isDot = 'xs' === size;
    const shouldShow = isDot || void 0 !== count && (count > 0 || showZero);
    const domProps = cleanProps(props, Object.keys(notificationBadgeVariants.variants));
    const displayCount = void 0 === count ? '' : formatCount(count, maxCount);
    const showAnimatedNumber = animated && void 0 !== count && count <= maxCount;
    function renderBadgeContent() {
        if (isDot) return null;
        if (showAnimatedNumber) return /*#__PURE__*/ jsx(SlidingNumber, {
            value: count,
            className: "inline-flex"
        });
        return displayCount;
    }
    const badgeContent = renderBadgeContent();
    if (children) {
        const { wrapper, badge, content } = notificationBadgeVariants({
            size,
            emphasis,
            standalone: false
        });
        return /*#__PURE__*/ jsxs("span", {
            ref: ref,
            className: cn(wrapper(), className),
            ...domProps,
            children: [
                shouldShow && /*#__PURE__*/ jsx("span", {
                    className: badge(),
                    style: computePositionStyle(offsetTop, offsetRight, offsetLeft, isDot),
                    "data-testid": "notification-badge",
                    children: badgeContent
                }),
                /*#__PURE__*/ jsx("span", {
                    className: content(),
                    children: children
                })
            ]
        });
    }
    if (!shouldShow) return null;
    const { badge } = notificationBadgeVariants({
        size,
        emphasis,
        standalone: true
    });
    return /*#__PURE__*/ jsx("span", {
        ref: ref,
        className: cn(badge(), className),
        "data-testid": "notification-badge",
        ...domProps,
        children: badgeContent
    });
});
export { NotificationBadge_NotificationBadge as NotificationBadge };
